<template>
  <v-row justify="center">
    <v-dialog
      v-model="active"
      persistent
      width="65%">
      <validation-observer
        ref="messageTemplateObs"
        tag="form"
        @submit.prevent="formSubmit">
        <v-container class="py-0">
          <v-row class="template-header primary">
            <code class="ma-2 white tamplate-header-title"><h1>MESSAGE #{{ templateIndex+1 }}</h1></code>
            <v-spacer />
            <v-btn
              color="warning"
              class="ma-2"
              @click="closeModal">
              ปิด
            </v-btn>
          </v-row>
          <v-row justify="center">
            <v-stepper
              v-model="stepper"
              vertical>
              <v-stepper-step
                step="1"
                :editable="stepper > 1 || !editable">
                เลือก Action
              </v-stepper-step>
              <v-stepper-content step="1">
                <action-step
                  :old-action="template.action"
                  :editable="editable"
                  :template-index="templateIndex"
                  @input="bindValue($event, 1)"
                  @step-back="stepControl(1, false)" />
              </v-stepper-content>
              <v-stepper-step
                step="2"
                :editable="stepper > 2 || !editable">
                เลือกความถี่
              </v-stepper-step>
              <v-stepper-content step="2">
                <frequency-step
                  :old-frequency="template.frequency"
                  :template-index="templateIndex"
                  :editable="editable"
                  @input="bindValue($event, 2)"
                  @step-back="stepControl(2, false)" />
              </v-stepper-content>
              <v-stepper-step
                step="3"
                :editable="stepper > 3 || !editable">
                กรอกข้อความ
              </v-stepper-step>
              <v-stepper-content step="3">
                <message-step
                  :editable="editable"
                  :old-msg="template.message"
                  @input="bindValue($event, 3)"
                  @step-back="stepControl(3, false)" />
              </v-stepper-content>
            </v-stepper>
          </v-row>
        </v-container>
      </validation-observer>
    </v-dialog>
  </v-row>
</template>

<script>
import ActionStep from './ActionStep.vue'
import FrequencyStep from './FrequencyStep.vue'
import MessageStep from './MessageStep.vue'

export default {
  components: {
    ActionStep,
    FrequencyStep,
    MessageStep
  },
  props: {
    active: {
      type: Boolean,
      required: true
    },
    oldTemplate: {
      type: Object,
      default: () => {}
    },
    templateIndex: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    stepper: 1,
    template: {
      templateIndex: -1,
      action: {
        action: '',
        more: {}
      },
      frequency: {
        field: '',
        more: {}
      },
      message: {
        type: [],
        text: '',
        img: []
      }
    }
  }),
  watch: {
    oldTemplate: {
      handler () {
        this.initTemplate()
      },
      deep: true
    },
    active: {
      handler () {
        this.initTemplate()
      }
    }
  },
  methods: {
    initTemplate () {
      this.template = this.oldTemplate
    },
    async formSubmit () {
      try {
        this.template.templateIndex = this.templateIndex
        const validated = await this.$refs.messageTemplateObs.validate()
        if (validated) {
          this.$emit('save', this.template)
        } else {
          this.setSnackBar({
            value: true,
            message: 'กรุณากรอกฟอร์มให้ถูกต้องและครบถ้วน',
            type: 'warning'
          })
        }
      } catch (e) {
        this.setSnackBar({
          value: true,
          message: `มีบางอย่างไม่ถูกต้อง (${e.message})`,
          type: 'error'
        })
      }
    },
    stepControl (step, addition) {
      if (step < 3 && addition) {
        this.stepper = step + 1
      } else if (step > 1 && !addition) {
        this.stepper = step - 1
      }
    },
    bindValue (val, step) {
      this.template = {
        ...this.template,
        ...val
      }

      if (step === 3) {
        this.formSubmit()
      } else {
        this.stepControl(step, true)
      }
    },
    closeModal () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.error-message {
  font-size: 11px;
}

.upload-container {
  width: 20%;
  height: 168px;
}

.preview-container {
  width: 20%;
  height: 168px;
  position: relative;
}

.preview-container input {
  font-size: 12px;
}

.preview-container .img-container {
  display: flex;
  height: 98px;
}

.preview-container .img-preview {
  align-self: center;
  margin-bottom: 36px;
  width: 100%;
}

.preview-container .close-img-field-btn{
  font-size: 16px;
  position: absolute;
  width: 24px;
  height: 24px;
  color: white;
  background-color: black;
  text-align: center;
  cursor: pointer;
  right: 0px;
  top: 0px;
}

.img-row {
  width: 100%;
  margin-top: 32px;
  margin-left: 12px;
}

.tamplate-header-title {
  border-radius: 10px;
  color: black;
}
</style>
